import Vue from 'vue'
import Vuex from 'vuex';
import accountModule from './modules/account.module';
import servicesModule from './modules/services.module';
import searchModule from "./modules/search.module";
import organizationModule from "./modules/organization.module";
import storeModule from "./modules/store.module";

Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        account: accountModule,
        services: servicesModule,
        search: searchModule,
        organization: organizationModule,
        store: storeModule,
    },
    state: {
        initialized: false,
        appName: "",
        appUrl: "",
        appLocale: "",  /*locale dell'app laravel server per logout*/
        customer: {},
        dealer: {},
        user: {},
        language:{},
        menu: {},
        sideMenu: {},
        notifications: {},
        authUrl: "",
    },
    getters: {
        getInit:        state => { return state.initialized; },
        getAppName:     state => { return state.appName; },
        getAppUrl:      state => { return state.appUrl; },
        getAppLocale:   state => { return state.appLocale; },
        getAppScope:    state => { return state.account.user.group; },

        getCustomer:    state => { console.debug('[Deprecated] Use submodule account to access getter'); return state.account.user.customer; },
        getUser:        state => { console.debug('[Deprecated] Use submodule account to access getter'); return state.account.user; },
        getLanguage:    state => { console.debug('[Deprecated] Use submodule account to access getter'); return state.account.language; },
        getTimezone:    state => { return state.account.user.timezone; },
        getAcls: state => { return state.acls; },

        getMenu:              state=> { return state.menu;},
        getSideMenu:          state=> { return state.sideMenu;},
        getNotifications:     state => { return state.notifications; },
        getAuthUrl:           state => state.authUrl,
    },
    mutations: {
        setInit (state, initState){ state.initialized = initState; },
        setAppName (state, name){ state.appName = name; },
        setAppUrl (state, url){ state.appUrl = url; },
        setAppLocale (state, locale){ state.appLocale = locale; },
        setCustomer (state, customer){ state.customer = customer; },
        setUser (state, user){ state.user = user; },
        setLanguage (state, language){ state.language = language; },
        setAcls (state, acls){ state.acls = acls; },
        setMenu( state, menu ) { state.menu = menu; },
        setSideMenu( state, sideMenu ) { state.sideMenu = sideMenu; },
        setAuthUrl( state, authUrl ) { state.authUrl = authUrl; },
    },
    actions: {
        init({commit}, laravel) {
            commit('setAppName',   laravel.config.app_name);
            commit('setAppUrl',    laravel.config.app_url);
            commit('setAppLocale', laravel.config.app_locale);
            commit('setAuthUrl', process.env.MIX_AUTH_URL || "")
        },
    }
})
